<template>
    <div class="form">
        <h4 class="step-title">
            <label for="VehicleYear">Vehicle Year</label>
        </h4>
        <div class="step-content d-flex flex-column">
            <scrollable-button-list v-bind:items="years" v-bind:onclick="complete"></scrollable-button-list>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "./shared/ScrollableButtonList.vue"

    export default {
        name: "VehicleYear",
        components: {
            ScrollableButtonList
        },
        props: {
            lead: Object
        },
        created: function() {
            // initialize vehicles if needed
            if (!this.lead.vehicles) {
                this.lead.vehicles = [{ "year": "", "make": "", "model": "", "trim": "", "vin": null}];
            }
        },
        computed: {
            vehicle: function () {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            },
            years: function () {
                var years = [];

                if (typeof window.AvengeDigitalWidgetYearMakeModelTrims !== "undefined") {
                    var yearsObject = window.AvengeDigitalWidgetYearMakeModelTrims;

                    Object.keys(yearsObject).forEach(function(key) {
                        years.push({ text: key, value: key });
                    });

                    // sort descending
                    years.sort().reverse();
                }
                else {
                    var year = new Date().getFullYear();

                    for(var i = 0; i < 20; i++) {
                        years.push({ text: year, value: year});
                        year--;
                    }
                }

                return years;
            }
        },
        methods: {
            complete: function(vehicleYear) {
                this.vehicle.year = vehicleYear;
                this.$emit("complete", this.$options.name, vehicleYear);
            }
        }
    }
</script>
